<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open()"
               :append-to-body="true"
               width="700px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">

        <el-form-item label="初试科目"
                      prop="subjects">
          <el-select v-model="dataForm.subjects"
                     placeholder="请选择科目"
                     clearable
                     multiple
                     style="width:100%;"
                     @change="subjectsChange">
            <el-option v-for="(item,index) in subjectsList"
                       :key="index"
                       :label="item.subject_name"
                       :value="{ value: item.subject_code, label: item.subject_name}">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="参考书目"
                      prop="reference_books">
          <el-input v-model="dataForm.reference_books"
                    type="textarea"
                    placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <div class="footers">
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  referenceBookCreated,
  referenceBookDetail,
  referenceBookPut,
} from '@/api/admission'
import { majorSubjectList } from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: () => {
        return '新建参考书目'
      },
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      rules: {
        subjects: [
          { required: true, message: '请选择科目', trigger: 'change' },
        ],
        reference_books: [
          { required: true, message: '请输入参考书目', trigger: 'blur' },
        ],
      },
      dataForm: { subjects: [], reference_books: '' },
      rowDetail: {},
      subjectsList: [],
    }
  },

  methods: {
    subjectsChange() {
      console.log('subject', this.dataForm.subjects)
      this.$forceUpdate()
    },
    handleClose() {
      this.$emit('close')
      this.dataForm = { subjects: [], reference_books: '' }
      this.$refs['dataForm'].resetFields()
    },
    getSubjects() {
      let query = {
        isPaging: 0,
        college_code: this.detail.college_code,
        major_code: this.detail.major_code,
      }
      majorSubjectList(query).then((res) => {
        this.subjectsList = res.list
      })
    },
    open() {
      this.getSubjects()
      if (this.title == '编辑参考书目') {
        referenceBookDetail({ id: this.rowId }).then((res) => {
          this.rowDetail = res
          if (this.rowDetail.subject_1_code) {
            this.dataForm.subjects.push({
              label: this.rowDetail.subject_1_name,
              value: this.rowDetail.subject_1_code,
            })
          }

          if (this.rowDetail.subject_2_code) {
            this.dataForm.subjects.push({
              label: this.rowDetail.subject_2_name,
              value: this.rowDetail.subject_2_code,
            })
          }
          if (this.rowDetail.subject_3_code) {
            this.dataForm.subjects.push({
              label: this.rowDetail.subject_3_name,
              value: this.rowDetail.subject_3_code,
            })
          }
          if (this.rowDetail.subject_4_code) {
            this.dataForm.subjects.push({
              label: this.rowDetail.subject_4_name,
              value: this.rowDetail.subject_4_code,
            })
          }
          console.log('this.dataform', this.dataForm)
          this.dataForm.reference_books = this.rowDetail.reference_books
          this.$forceUpdate()
        })
      }
    },
    handleSubmit() {
      console.log('this.dataform', this.dataForm)
      console.log('this.daform', this.dataForm.subjects[3])
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.dataForm.subjects.length > 4) {
            this.$message.error(`初试科目最多只能选择4个`)
            return
          }
          if (this.title == '新建参考书目') {
            let data = {
              year: this.detail.current_search_year,
              college_code: this.detail.college_code,
              college_name: this.detail.college_name,
              reference_books: this.dataForm.reference_books,
            }
            if (this.dataForm.subjects[0]) {
              data.subject_1_code = this.dataForm.subjects[0].value
              data.subject_1_name = this.dataForm.subjects[0].label
            }
            if (this.dataForm.subjects[1]) {
              data.subject_2_code = this.dataForm.subjects[1].value
              data.subject_2_name = this.dataForm.subjects[1].label
            }
            if (this.dataForm.subjects[2]) {
              data.subject_3_code = this.dataForm.subjects[2].value
              data.subject_3_name = this.dataForm.subjects[2].label
            }
            if (this.dataForm.subjects[3]) {
              data.subject_4_code = this.dataForm.subjects[3].value
              data.subject_4_name = this.dataForm.subjects[3].label
            }
            referenceBookCreated(data).then((res) => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`操作成功`)
            })
          } else {
            let data = {
              id: this.rowId,
              year: this.detail.current_search_year,
              college_code: this.detail.college_code,
              college_name: this.detail.college_name,
              reference_books: this.dataForm.reference_books,
            }
            if (this.dataForm.subjects[0]) {
              data.subject_1_code = this.dataForm.subjects[0].value
              data.subject_1_name = this.dataForm.subjects[0].label
            }
            if (this.dataForm.subjects[1]) {
              data.subject_2_code = this.dataForm.subjects[1].value
              data.subject_2_name = this.dataForm.subjects[1].label
            }
            if (this.dataForm.subjects[2]) {
              data.subject_3_code = this.dataForm.subjects[2].value
              data.subject_3_name = this.dataForm.subjects[2].label
            }
            if (this.dataForm.subjects[3]) {
              data.subject_4_code = this.dataForm.subjects[3].value
              data.subject_4_name = this.dataForm.subjects[3].label
            }
            referenceBookPut(data).then((res) => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`修改成功`)
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 112px;
  height: 112px;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  max-width: 100%;
  max-height: 200px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin: 0 auto;
}
.border {
  padding: 10px;
  width: 100%;
  border: 1px dashed #d9d9d9;
}
.desc {
  margin-top: 10px;
  font-weight: normal;
  font-size: 12px;
  color: #cccccc;
}
.footers {
  display: flex;
  justify-content: flex-end;
}
</style>
